import React, { useEffect, useState } from 'react'

const useToken = () => {
    const [token,setToken] = useState(null);
    useEffect(() => {
        setToken(localStorage.getItem('token'))
    },[]);
    return token;
}

export default useToken